import { render, staticRenderFns } from "./AccountUnc.vue?vue&type=template&id=7f8be20a&"
import script from "./AccountUnc.vue?vue&type=script&lang=js&"
export * from "./AccountUnc.vue?vue&type=script&lang=js&"
import style0 from "./AccountUnc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports